import * as React from "react";
import { isMobileOnly } from "react-device-detect";
import { Col, Row } from "reactstrap";
import { AccentButton } from "../controls/AccentButton";
import { AccentAddress, AccentAddressNoViewState } from "../controls/bound/AccentAddress";
import { getCustomProperties, RTLContactMatchResult } from "../controls/leads/WebLeads";
import { NewContactCtrl } from "../controls/NewContactCtrl";
import { AccentCheckUnbound } from "../controls/unbound/AccentCheckUnbound";
import { AccentRadioUnboundCustom } from "../controls/unbound/AccentRadioUnbound";
import { NewLeadGrid } from "../grids/NewLeadGrid";
import { queryNoTracking, update } from "../services/DataService";
import { accentUtils, formHelper, goTo, isMobileNumber, isPhoneNumber, t } from "../services/HelperService";
import { getUser } from "../services/UserService";
import { getCountryCode } from "../services/GlobalizationService";

const query_Contacts_Match = queryNoTracking("Contacts_Match", undefined, true);
const query_NewLead_LoadContact = queryNoTracking("NewLead_LoadContact");
const query_Contact = queryNoTracking("Contact");

const NewLeadWizardTitle = (props) => {

    var info = accentUtils.isEmpty(props.selectedInfo) ? "\u00a0" : t(props.selectedInfo);

    return (
        <div className="newlead-wiz-title">
            <div>
                <span >{t(props.title)}</span>
            </div>
            <div>
                <span >{info}</span>
            </div>
        </div>
    )
};




export class NewLeadWizardData {

    constructor(props) {

        this.SiteContactSelection = 1;
        this.SiteAddressSelection = null;
        this.LinkContactToCompany = false;
        this.AddCompany = false;
        this.WebLead = null;
        if (!accentUtils.isNull(props)) {

            if (!accentUtils.isNull(props.SiteContactSelection)) {
                this.SiteContactSelection = props.SiteContactSelection;
            }
            if (!accentUtils.isNull(props.SiteAddressSelection)) {
                this.SiteAddressSelection = props.SiteAddressSelection;
            }
            if (!accentUtils.isNull(props.LinkContactToCompany)) {
                this.LinkContactToCompany = props.LinkContactToCompany;
            }
            if (!accentUtils.isNull(props.WebLead)) {
                this.WebLead = props.WebLead;
            }
            if (!accentUtils.isNull(props.AddCompany)) {
                this.AddCompany = props.AddCompany;
            }
        }


        this.BillingContact = this.newContact();
        this.BillingCompany = this.newCompany();

        this.JobContact = this.newContact();

        this.OtherContact = this.newContact();

        this.SiteAddress = {
            setProperty: function (name, val) {
                this[name] = val;
            }
        };


        this.isNewCustomerLead = this.isNewCustomerLead.bind(this);
        this.isBillingContactSameAsJobContact = this.isBillingContactSameAsJobContact.bind(this);
        this.getBillingContactFullName = this.getBillingContactFullName.bind(this);
        this.getJobContactFullName = this.getJobContactFullName.bind(this);
        this.getOtherContactFullName = this.getOtherContactFullName.bind(this);
        this.isContactEmpty = this.isContactEmpty.bind(this);
        this.isJobContactEmpty = this.isJobContactEmpty.bind(this);
        this.isSelectedSiteContactEmpty = this.isSelectedSiteContactEmpty.bind(this);
        this.isBillingContactEmpty = this.isBillingContactEmpty.bind(this);
        this.getSelectedContact = this.getSelectedContact.bind(this);
        this.isBillingCompanyEmpty = this.isBillingCompanyEmpty.bind(this);
        this.isOtherContactNew = this.isOtherContactNew.bind(this);
        this.getContactFullName = this.getContactFullName.bind(this);
        this.getSelectedSiteContactFullName = this.getSelectedSiteContactFullName.bind(this);
        this.clearOtherContact = this.clearOtherContact.bind(this);
        this.newContact = this.newContact.bind(this);
        this.newCompany = this.newCompany.bind(this);
        this.setSiteAddress = this.setSiteAddress.bind(this);
        this.setBillingContact = this.setBillingContact.bind(this);
        this.setBillingCompany = this.setBillingCompany.bind(this);
        this.setJobContact = this.setJobContact.bind(this);
        this.setOtherContact = this.setOtherContact.bind(this);
        this.toEntity = this.toEntity.bind(this);
        this.isSelectedSiteContactAddressEmpty = this.isSelectedSiteContactAddressEmpty.bind(this);
        this.isAddressEmpty = this.isAddressEmpty.bind(this);
    }


    defaultSiteAddress() {

        this.SiteAddressSelection = 3;

        if (this.isNewCustomerLead()) {
            if (this.isSelectedSiteContactAddressEmpty()) {
                this.SiteAddressSelection = 1;
                this.setSiteAddress(this.BillingContact.Address);
            } else {
                this.SiteAddressSelection = 2;
                this.setSiteAddress(this.getSelectedContact().Address);
            }
        }


    }

    newContact() {
        return {
            Address: {
                setProperty: function (name, val) {
                    this[name] = val;
                }
            },
            setProperty: function (name, val) {
                this[name] = val;
            }
        };
    }

    newCompany() {
        return {
            Address: {
                setProperty: function (name, val) {
                    this[name] = val;
                }
            },
            setProperty: function (name, val) {
                this[name] = val;
            }
        };
    }

    getSelectedContact() {
        if (this.SiteContactSelection === 1) {
            return this.BillingContact;
        } else if (this.SiteContactSelection === 3) {
            return this.OtherContact;
        }

        return this.JobContact;
    }

    getSelectedSiteContactFullName() {
        var contact = this.getSelectedContact();
        return this.getContactFullName(contact);
    }

    setBillingContact(contact) {
        this.BillingContact = contact;
        this.BillingContact = this.toEntity(this.BillingContact);
    }
    setBillingCompany(company) {

        this.BillingCompany = company;

        if (accentUtils.isNull(this.BillingCompany)) {
            this.BillingCompany = this.newCompany();
        }


        this.BillingCompany = this.toEntity(this.BillingCompany);
    }
    setJobContact(contact) {
        this.JobContact = contact;
        this.JobContact = this.toEntity(this.JobContact);
    }
    setOtherContact(contact) {
        this.OtherContact = contact;
        this.OtherContact = this.toEntity(this.OtherContact);
    }

    toEntity(obj) {

        var res = accentUtils.toPlanObject(obj);

        res.setProperty = function (name, val) {
            this[name] = val;
        };


        if (!accentUtils.isNull(res.Address)) {
            res.Address.setProperty = function (name, val) {
                this[name] = val;
            };
        }

        return res;

    }

    setSiteAddress(address) {

        this.SiteAddress.AddressLines = accentUtils.isNull(address) ? "" : address.AddressLines;
        this.SiteAddress.City = accentUtils.isNull(address) ? "" : address.City;
        this.SiteAddress.State = accentUtils.isNull(address) ? "" : address.State;
        this.SiteAddress.StateSubArea1 = accentUtils.isNull(address) ? "" : address.StateSubArea1;
        this.SiteAddress.Postcode = accentUtils.isNull(address) ? "" : address.Postcode;
        this.SiteAddress.Country = accentUtils.isNull(address) ? "" : address.Country;
        this.SiteAddress.PosLong = accentUtils.isNull(address) ? null : address.PosLong;
        this.SiteAddress.PosLat = accentUtils.isNull(address) ? null : address.PosLat;

    }

    isAddressEmpty(address) {
        return accentUtils.isNull(address) || accentUtils.isEmpty(address.AddressLines);
    }

    isSelectedSiteContactAddressEmpty() {

        if (this.isSelectedSiteContactEmpty())
            return false;

        return this.isAddressEmpty(this.getSelectedContact().Address);
    }

    clearOtherContact() {
        this.OtherContact = this.newContact();
    }

    isContactEmpty(contact) {
        return accentUtils.isNull(contact) || (accentUtils.isEmpty(contact.FirstName) && accentUtils.isEmpty(contact.LastName));
    }

    isSelectedSiteContactEmpty() {

        var contact = this.getSelectedContact();

        return this.isContactEmpty(contact);
    }


    isJobContactEmpty() {
        return this.isContactEmpty(this.JobContact);
    }

    isBillingContactEmpty() {
        return this.isContactEmpty(this.BillingContact);
    }

    isNewCustomerLead() {
        return accentUtils.isEmpty(this.BillingContact.ID);
    }

    isBillingContactSameAsJobContact() {
        return !accentUtils.isEmpty(this.BillingContact.ID) && this.BillingContact.ID === this.JobContact.ID;
    }


    isBillingCompanyEmpty() {
        return accentUtils.isNull(this.BillingCompany) || (accentUtils.isEmpty(this.BillingCompany.ID) && accentUtils.isEmpty(this.BillingCompany.Name))
    }

    isOtherContactNew() {
        return !accentUtils.isNull(this.OtherContact) && accentUtils.isEmpty(this.OtherContact.ID);
    }


    getContactFullName(contact) {

        var fname = "{0} {1}".format(accentUtils.isEmpty(contact.FirstName) ? "" : contact.FirstName, accentUtils.isEmpty(contact.LastName) ? "" : contact.LastName);

        if (fname === " ") {
            fname = "";
        }

        return fname;

    }

    getOtherContactFullName() {
        return this.getContactFullName(this.OtherContact);
    }

    getBillingContactFullName() {
        return this.getContactFullName(this.BillingContact);
    }
    getJobContactFullName() {
        return this.getContactFullName(this.JobContact);
    }
}

export default class newLeadWizardModel {


    constructor(props) {

        
        
        
        this.title = "application_strings.wizards.newLead.title";
        this.activePageIndex = 0;

        this.searchRun = false;
        this.selectedCustomer = null;
        this.data = null;
        this.lastSearchText = null;


        this.onCustomerCompanyLoaded = this.onCustomerCompanyLoaded.bind(this);
        this.onAddCompanyChange = this.onAddCompanyChange.bind(this);
        this.finish = this.finish.bind(this);
        this.resetData = this.resetData.bind(this);
        this.refreshWizard = this.refreshWizard.bind(this);
        this.select = this.select.bind(this);
        this.getPages = this.getPages.bind(this);
        this.getActivePageIndex = this.getActivePageIndex.bind(this);
        this.getContentWithSidebar = this.getContentWithSidebar.bind(this);
        this.getPageContent = this.getPageContent.bind(this);
        this.getPageButtons = this.getPageButtons.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.isPageValid = this.isPageValid.bind(this);
        this.loadContactDetails = this.loadContactDetails.bind(this);
        this.onExistingCustomerSelected = this.onExistingCustomerSelected.bind(this);
        this.getCustomerDetailsContent = this.getCustomerDetailsContent.bind(this);
        this.getSiteAddressContent = this.getSiteAddressContent.bind(this);
        this.onNewBillingDetailsChanged = this.onNewBillingDetailsChanged.bind(this);
        this.copyNewDetailsToContact = this.copyNewDetailsToContact.bind(this);
        this.getData = this.getData.bind(this);
        this.defaultFromSearchText = this.defaultFromSearchText.bind(this);
        this.getCustomerSearchContent = this.getCustomerSearchContent.bind(this);
        this.getSiteContactContent = this.getSiteContactContent.bind(this);

        this.pages = [
            {
                title: "application_strings.wizards.newLead.customerSearch.title",
                disabled: false,
            },
            {
                title: "application_strings.wizards.newLead.customerDetails.title",
                disabled: true,
            },
            {
                title: "application_strings.wizards.newLead.siteContact.title",
                disabled: true,
            },
            {
                title: "application_strings.wizards.newLead.siteAddress.title",
                disabled: true,
            }
        ];



        if (accentUtils.isNull(props.data)) {
            this.resetData();
        } else {
            this.data = props.data;

            if (!accentUtils.isEmpty(this.data.BillingContact.ID)) {
                this.selectedCustomer = {
                    ID: this.data.JobContact.ID,
                    BillingContactName: this.data.getBillingContactFullName(),
                    CustomerName: this.data.getJobContactFullName(),
                    CompanyName: this.data.isBillingCompanyEmpty() ? null : this.data.BillingCompany.Name
                };


                this.data.SiteContactSelection = 2;
            }

        }


        if (!accentUtils.isEmpty(props.defaultPageIndex)) {
            this.select(props.defaultPageIndex);
        }

        if (!accentUtils.isNull(props.searchRun)) {
            this.searchRun = props.searchRun;
        }



    }

    defaultFromSearchText() {
        var text = this.lastSearchText;



        if (!accentUtils.isEmpty(text)) {

            var country = getCountryCode();

            if (isPhoneNumber(text, country)) {
                if (isMobileNumber(text, country)) {
                    this.data.BillingContact.Mobile = text;
                } else {
                    this.data.BillingContact.WorkPhone = text;
                }

            } else if (accentUtils.isEmail(text)) {
                this.data.BillingContact.Email = text;
            } else {
                var name = accentUtils.fullNameToObject(text, true);

                this.data.BillingContact.FirstName = name.FirstName;
                this.data.BillingContact.LastName = name.LastName

            }


        }
    }

    refreshWizard() {
        this.refresh();
    }
    onCustomerCompanyLoaded(e) {

        if (accentUtils.isNull(e.company)) {
            this.data.setBillingCompany(null);
        } else {
            this.data.setBillingCompany(e.company);
        }
        e.company = this.data.BillingCompany;

    }

    onAddCompanyChange(addCompany) {
        this.data.AddCompany = addCompany;
    }


    resetData(defaults) {
        this.data = new NewLeadWizardData(defaults);
    }

    getData() {
        return this.data;
    }


    finish() {

        const model = { ...this.data };

        if (accentUtils.isNull(model.BillingCompany?.Name)) {
            model.BillingCompany = null;
        }


        
        return update("NewLead", model).then(function (res) {
            goTo(`/Opportunity/${res}`);            
        });
    }

    copyNewDetailsToContact(details, contact) {
        contact.FirstName = details.FirstName;
        contact.LastName = details.LastName;
        contact.Email = details.Email;
        contact.Mobile = details.Mobile;
        contact.WorkPhone = details.WorkPhone;
        contact.HomePhone = details.HomePhone;
        contact.CompanyID = details.CompanyID;

        contact.Address.AddressLines = details.ContactAddress.AddressLines;
        contact.Address.City = details.ContactAddress.City;
        contact.Address.State = details.ContactAddress.State;
        contact.Address.StateSubArea1 = details.ContactAddress.StateSubArea1;
        contact.Address.Postcode = details.ContactAddress.Postcode;
        contact.Address.Country = details.ContactAddress.Country;

    }

    onNewBillingDetailsChanged(details) {
        if (accentUtils.isNull(this.newCustomerLeadDetails)) {
            this.newCustomerLeadDetails = {
                BillingContact: {
                    Address: {
                    }
                },
                JobContact: {
                    Address: {
                    }
                }
            };
        }

        this.copyNewDetailsToContact(details, this.newCustomerLeadDetails.BillingContact);

        
    }

    loadContactDetails(id) {
        var me = this;
        return query_NewLead_LoadContact.getFirstOrDefault({ contactID : id }).then(function (details) {

            me.resetData({ SiteContactSelection: me.data.SiteContactSelection, AddCompany: !accentUtils.isNull(details.Company) });

            me.data.setBillingContact(details.BillingContact);
            me.data.setJobContact(details.JobContact);

            if (!accentUtils.isNull(details.Company)) {
                me.data.setBillingCompany(details.Company);
            }
        });

    }

    onExistingCustomerSelected(row) {

        this.selectedCustomer = row;

        this.refreshWizard();
    }


    isPageValid(index) {
        return formHelper.isWizardValid();
    }

    select(index) {

        var me = this;


        return new Promise(function (p) {
            var isValid = me.isPageValid(me.activePageIndex) || index < me.activePageIndex;

            if (isValid) {
                me.activePageIndex = index;
                me.pages[index].disabled = false;

                if (index == 0) {
                    me.resetData();
                } else if (index === 3) {
                    if (accentUtils.isNull(me.data.SiteAddressSelection)) {
                        me.data.defaultSiteAddress();
                    }
                }

                for (var i = index + 1; i < me.pages.length; i++) {
                    me.pages[i].disabled = true;
                }

            }
            p({ isValid: isValid });
        });
    }

    onButtonClick(btn) {
        var me = this;
        return new Promise(function (p) {
            if (btn.id === 1) {
                me.select(1)
                    .then(r => p(r));
                me.data.SiteContactSelection = 2;
            } else if (btn.id === 2) {
                me.selectedCustomer = null;
                me.resetData();
                me.defaultFromSearchText();
                me.select(1).then(r => p(r));
            } else if (btn.id === 3) { //prev
                me.select(me.activePageIndex - 1).then(r => p(r));
            } else if (btn.id === 4) { //prev

                if (me.activePageIndex === 1) {// default job contact to billing if new lead
                    if (me.data.isNewCustomerLead() && me.data.SiteContactSelection === 1) {
                        me.data.setJobContact({ ...me.data.BillingContact });
                    }
                }

                me.select(me.activePageIndex + 1).then(r => p(r));
            } else {

                var isvalid = me.isPageValid(me.activePageIndex);

                if (isvalid) {
                    me.finish().then(function () {
                        p({ isValid: true, isFinished: true });
                    })
                } else {
                    p({ isValid: false });
                }


            }
        });
    }

    getPages() {

        var pages = [];


        var billingContact = accentUtils.isNull(this.selectedCustomer) ? "" : this.selectedCustomer.BillingContactName;
        var siteContact = accentUtils.isNull(this.selectedCustomer) ? "" : this.selectedCustomer.CustomerName;;
        var siteAddress = accentUtils.isNull(this.data.SiteAddress.AddressLines) ? "" : this.data.SiteAddress.AddressLines;


        if (!this.data.isBillingContactEmpty()) {
            billingContact = this.data.getBillingContactFullName();
        }

        if (!this.data.isSelectedSiteContactEmpty()) {
            siteContact = this.data.getSelectedSiteContactFullName();
        }

        var index = 0;

        var result = [];

        result.push({
            titleItem: <NewLeadWizardTitle title={this.pages[index].title} selectedInfo="" />,
            ...this.pages[index++],
        });

        result.push({
            titleItem: <NewLeadWizardTitle title={this.pages[index].title} selectedInfo={billingContact} />,
            ...this.pages[index++],
        });
        result.push({
            titleItem: <NewLeadWizardTitle title={this.pages[index].title} selectedInfo={siteContact} />,
            ...this.pages[index++],
        });

        result.push({
            titleItem: <NewLeadWizardTitle title={this.pages[index].title} selectedInfo={siteAddress} />,
            ...this.pages[index++],
        });


        return result;
    }




    getCustomerSearchContent() {
        var me = this;
        return new Promise(p => {
            p(<NewLeadGrid onSelectExisting={me.onExistingCustomerSelected} onSearch={function (e) {
                me.lastSearchText = e;
                me.searchRun = true;
                me.refreshWizard();
            }} />);
        });
    }



    getContentWithSidebar(content, sideBarCols) {
        //var sideBar = <WebLeadDataCtrl key={1} webLeadData={} col={4} />;



        if (accentUtils.isNull(this.data.WebLead)) {
            return content;
        }

        var contentCol = 12 - sideBarCols;

        return <Row>
            <Col md={contentCol}>{content}</Col>
            <NewLeadSideBar key={1} webLeadData={this.data.WebLead} col={sideBarCols} />
        </Row>;
    }

    getCustomerDetailsContent() {
        var me = this;
        return new Promise(p => {



            if (accentUtils.isNull(me.selectedCustomer)) {
                p(me.getContentWithSidebar(<NewContactCtrl contact={me.data.BillingContact} company={me.data.BillingCompany} onChange={me.refreshWizard} onCompanyLoaded={me.onCustomerCompanyLoaded} onAddCompanyChange={me.onAddCompanyChange} />, 4));
            } else {


                var titleData = {
                    Company: me.selectedCustomer.CompanyName,
                    Contact: me.selectedCustomer.CustomerName
                };

                if (me.data.JobContact.ID !== me.selectedCustomer.ID) {

                    me.loadContactDetails(me.selectedCustomer.ID).then(function () {
                        p(me.getContentWithSidebar(<NewContactCtrl contactTitle={t("application_strings.wizards.newLead.customerDetails.contactTitle", titleData)} contact={me.data.BillingContact} company={me.data.BillingCompany} onChange={me.refreshWizard} onCompanyLoaded={me.onCustomerCompanyLoaded} onAddCompanyChange={me.onAddCompanyChange} />, 4));
                    });

                } else {
                    p(me.getContentWithSidebar(<NewContactCtrl contact={me.data.BillingContact} company={me.data.BillingCompany} onChange={me.refreshWizard} onAddCompanyChange={me.onAddCompanyChange} onCompanyLoaded={me.onCustomerCompanyLoaded} />, 4));
                }


            }
        });
    }

    getSiteContactContent() {
        var me = this;
        return new Promise(p => {
            p(me.getContentWithSidebar(<NewLeadSiteContactCtrl userModel={this.userModel} getData={me.getData} onContactChange={me.refreshWizard} />, 4));
        });
    }


    getSiteAddressContent() {
        var me = this;
        return new Promise(p => {
            p(me.getContentWithSidebar(<NewLeadSiteAddressCtrl userModel={this.userModel} getData={me.getData} onAddressChange={me.refreshWizard} />, 4));
        });
    }

    getPageContent(index) {


        if (index === 0) {
            return this.getCustomerSearchContent();
        } else if (index === 1) {
            return this.getCustomerDetailsContent();
        } else if (index === 2) {
            return this.getSiteContactContent();
        } else {
            return this.getSiteAddressContent();
        }


    }

    getActivePageIndex() {
        return this.activePageIndex;
    }

    getPageButtons(index) {

        var maxIndex = this.pages.length - 1;

        var result = [];


        if (index === 0) {
            if (this.searchRun) {
                if (!accentUtils.isNull(this.selectedCustomer)) {
                    if (isMobileOnly) {
                        result.push({ text: t("application_strings.wizards.newLead.customerSearch.existingCustomer", { ...this.selectedCustomer, interpolation: { escapeValue: false } }), onClick: this.onButtonClick, id: 1, tagName: "ExistingCustomer" });
                    } else {
                        result.push({ text: t("application_strings.wizards.newLead.customerSearch.existingCustomer", { ...this.selectedCustomer, interpolation: { escapeValue: false } }), onClick: this.onButtonClick, id: 1, tagName: "ExistingCustomer" });
                    }
                }
                result.push({ text: "application_strings.wizards.newLead.customerSearch.newCustomer", onClick: this.onButtonClick, id: 2, tagName: "NewCustomer" });
            }
        } else {

            if (index > 0) result.push({ text: "application_strings.application.buttons.previous", onClick: this.onButtonClick, id: 3, tagName: "Previous" });
            if (index < maxIndex) result.push({ text: "application_strings.application.buttons.next", onClick: this.onButtonClick, id: 4, tagName: "Next" });
            if (index === maxIndex) result.push({ text: "application_strings.application.buttons.finish", onClick: this.onButtonClick, id: 5, tagName: "Finish" });
        }

        return result;
    }
};




class NewLeadSiteContactCtrl extends React.Component {

    constructor(props) {
        super(props);

        this.linkContactToCompanyKey = 0;
        this.siteContactMatches = [];
        var data = this.props.getData();

        this.contactSelection = data.SiteContactSelection;
        this.selectBillingContact = this.selectBillingContact.bind(this);
        this.selectJobContact = this.selectJobContact.bind(this);
        this.selectOther = this.selectOther.bind(this);
        this.searchContacts = this.searchContacts.bind(this);
        this.selectMatch = this.selectMatch.bind(this);
        this.linkContactToCompany = this.linkContactToCompany.bind(this);
        this.clearOtherContact = this.clearOtherContact.bind(this);
    }

    selectBillingContact() {
        var data = this.props.getData();
        data.SiteContactSelection = 1;
        this.forceUpdate();
        this.props.onContactChange();
    }
    selectJobContact() {
        var data = this.props.getData();
        data.SiteContactSelection = 2;
        this.forceUpdate();
        this.props.onContactChange();
    }
    selectOther() {
        var data = this.props.getData();
        data.SiteContactSelection = 3;
        this.forceUpdate();
        this.props.onContactChange();
    }

    linkContactToCompany(e) {
        var data = this.props.getData();
        data.LinkContactToCompany = e.checked;
        this.forceUpdate();

    }
    selectMatch(contactID) {
        var me = this;

        query_Contact.getFirstOrDefault({ id: contactID, include: "Address" }).then(function (contact) {
            var data = me.props.getData();
            data.setOtherContact(contact);
            me.forceUpdate();
        });
    }
    clearOtherContact() {
        var data = this.props.getData();
        data.clearOtherContact();
        this.siteContactMatches = [];
        this.forceUpdate();
    }
    searchContacts() {

        var me = this;
        var data = this.props.getData();

        if (data.SiteContactSelection !== 3) {
            me.props.onContactChange();
            return;
        }

        var otherContact = data.getSelectedContact();

        var search = {
            FirstName: otherContact.FirstName,
            LastName: otherContact.LastName,
            Mobile: otherContact.Mobile,
            HomePhone: otherContact.HomePhone,
            WorkPhone: otherContact.WorkPhone,
            Email: otherContact.Email
        };

        query_Contacts_Match.getAllWithCache(search).then(function (res) {
            me.siteContactMatches = res;
            me.props.onContactChange();
            me.forceUpdate();
        });

    }

    render() {

        var me = this;


        var data = this.props.getData();


        var billingDifferent = !data.isBillingContactSameAsJobContact();
        var newCustomer = data.isNewCustomerLead();
        var jobContactEmpty = data.isJobContactEmpty();

        var optionCtrls = [];

        if (billingDifferent || jobContactEmpty) {
            optionCtrls.push(<Col key="siteContBilling" md={2}>
                <AccentRadioUnboundCustom
                    checked={this.contactSelection === 1}
                    name="siteContactOptions"
                    id="siteContBilling"
                    onChange={me.selectBillingContact}
                    label={t("application_strings.wizards.newLead.siteContact.selectBillingContact", { FullName: data.getBillingContactFullName(), interpolation: { escapeValue: false } })} />
            </Col>);
        }

        if (!jobContactEmpty && !data.isNewCustomerLead()) {
            optionCtrls.push(<Col key="siteContContact" md={2}>
                <AccentRadioUnboundCustom
                    checked={this.contactSelection === 2}
                    name="siteContactOptions"
                    id="siteContContact"
                    onChange={me.selectJobContact}
                    label={t("application_strings.wizards.newLead.siteContact.selectContact", { FullName: data.getJobContactFullName(), interpolation: { escapeValue: false } })} />
            </Col>);
        }
        optionCtrls.push(<Col key="siteContOther" md={2}>
            <AccentRadioUnboundCustom
                checked={this.contactSelection === 3}
                name="siteContactOptions"
                id="siteContOther"
                onChange={me.selectOther}
                label={t("application_strings.wizards.newLead.siteContact.selectOther")} /></Col>);


        var options = <Row>
            {optionCtrls}
        </Row>;

        var contact = data.getSelectedContact();

        var cKey = "cont_details_" + data.SiteContactSelection + "_" + (accentUtils.isNull(contact) ? "n" : contact.ID);

        var linkToCompanyVisible = data.SiteContactSelection === 3 && data.isOtherContactNew() && !data.isBillingCompanyEmpty();

        if (!linkToCompanyVisible) {
            data.LinkContactToCompany = false;
            this.linkContactToCompanyKey++;
        }

        var linkToCompany = <AccentCheckUnbound key={this.linkContactToCompanyKey} defaultValue={data.LinkContactToCompany} hide={!linkToCompanyVisible} label={t("application_strings.wizards.newLead.siteContact.linkToCompany", data.BillingCompany)} onChange={this.linkContactToCompany} tagName="linkToCompany" />;






        var newCustomerDetails = null;

        var disableSiteContactNames = data.SiteContactSelection !== 3 || !data.isOtherContactNew();


        if (billingDifferent || data.SiteContactSelection === 3) {
            newCustomerDetails = <NewContactCtrl key={cKey} contact={contact} hideCompany hideContactAddres hideTitles disableNames={disableSiteContactNames} onChange={this.searchContacts} />;
        }

        var matches = null;
        var clearMatchSelection = null;
        if (data.SiteContactSelection === 3) {
            matches = this.siteContactMatches.map(function (m) {
                return <RTLContactMatchResult model={m} onSelect={me.selectMatch} selectTitle="application_strings.wizards.newLead.siteContact.selectExisting" />;
            });

            if (matches.length > 0) {
                matches.unshift(
                    <Row>
                        <Col md="12"><strong>{t("application_strings.wizards.newLead.siteContact.matchTitle")}</strong></Col>
                    </Row>);

                if (!data.isOtherContactNew()) {

                    clearMatchSelection =
                        <Row>
                            <Col md="12"><AccentButton onClick={this.clearOtherContact} tagName="clearLeadSel">{t("application_strings.wizards.newLead.siteContact.clearMatch", { FullName: data.getOtherContactFullName() })}</AccentButton></Col>
                        </Row>;

                }

            }
        }


        return <React.Fragment>

            {options}
            <hr />
            <Row>
                <Col md={6}>
                    {linkToCompany}
                    {newCustomerDetails}
                    {clearMatchSelection}
                </Col>
                <Col md={6}>
                    {matches}
                </Col>
            </Row>
        </React.Fragment>;

    }
}




class NewLeadSiteAddressCtrl extends React.Component {

    constructor(props) {
        super(props);

        this.addressRefreshKey = 1;
        var data = this.props.getData();

        this.addressModel = {
            viewModel: {
                userModel: getUser(),
                entity: data.SiteAddress
            }
        };

        this.selectBillingContact = this.selectBillingContact.bind(this);
        this.selectJobContact = this.selectJobContact.bind(this);
        this.selectOther = this.selectOther.bind(this);


    }

    selectBillingContact() {

        var data = this.props.getData();
        data.SiteAddressSelection = 1;
        data.setSiteAddress(data.BillingContact.Address);
        this.addressRefreshKey++;
        this.forceUpdate();

        this.props.onAddressChange();
    }
    selectJobContact() {

        var data = this.props.getData();
        data.SiteAddressSelection = 2;
        var siteContact = data.getSelectedContact();

        data.setSiteAddress(siteContact.Address);
        this.addressRefreshKey++;
        this.forceUpdate();
        this.props.onAddressChange();
    }
    selectOther() {

        var data = this.props.getData();
        data.SiteAddressSelection = 3;
        data.setSiteAddress(null);
        this.addressRefreshKey++;
        this.forceUpdate();
        this.props.onAddressChange();
    }


    render() {

        var me = this;


        var data = this.props.getData();


        var optionCtrls = [];


        var billingName = data.getBillingContactFullName();
        var siteName = data.getSelectedSiteContactFullName();
        var billingSameAsSite = billingName.toUpperCase() === siteName.toUpperCase();

        var showJobAddress = !data.isSelectedSiteContactAddressEmpty();


        if (!billingSameAsSite) {
            optionCtrls.push(<Col key="siteContBilling" md={2}>
                <AccentRadioUnboundCustom
                    checked={data.SiteAddressSelection === 1}
                    name="siteContactAddrOptions"
                    id="siteAddrContBilling"
                    onChange={me.selectBillingContact}
                    label={t("application_strings.wizards.newLead.siteAddress.selectBillingContact", { FullName: billingName, interpolation: { escapeValue: false } })} />
            </Col>);
        }

        if (!accentUtils.isEmpty(siteName) && showJobAddress) {
            optionCtrls.push(<Col key="siteContContact" md={2}>
                <AccentRadioUnboundCustom
                    checked={data.SiteAddressSelection === 2}
                    name="siteContactAddrOptions"
                    id="siteAddrContContact"
                    onChange={me.selectJobContact}
                    label={t("application_strings.wizards.newLead.siteAddress.selectContact", { FullName: siteName, interpolation: { escapeValue: false } })} />
            </Col>);
        }

        optionCtrls.push(<Col key="siteContOther" md={2}>
            <AccentRadioUnboundCustom
                checked={data.SiteAddressSelection === 3}
                name="siteContactAddrOptions"
                id="siteAddrContOther"
                onChange={me.selectOther}
                label={t("application_strings.wizards.newLead.siteAddress.selectOther")} /></Col>);


        var options = <Row>
            {optionCtrls}
        </Row>;

        return <React.Fragment>
            {options}
            <hr />
            <Row><Col md={12}><label>{t("application_strings.wizards.newLead.siteAddress.siteAddress")}</label></Col></Row>
            <Row><Col md={6}><AccentAddressNoViewState key={this.addressRefreshKey } entity={this.addressModel.viewModel.entity} addressMember={null} required={true} onChange={this.props.onAddressChange} /></Col></Row>
        </React.Fragment>;
    }
}



const NewLeadSideBar = React.memo(props => {

    const leadData = props.webLeadData;


    const customProperties = getCustomProperties(leadData);

    let poi = null;

    if (!accentUtils.isNull(leadData.ProductsOfInterest)) {
        poi = leadData.ProductsOfInterest.map(function (p) {

            return <Row>
                <Col md="9"><label>{p.Description}</label></Col>
                <Col md="3">{p.Qty}</Col>
            </Row>;
        });

    }

    const custom = customProperties.map(function (p) {

        return <Row>
            <Col md="4"><label>{p.Name}</label></Col>
            <Col md="8">{p.Value}</Col>
        </Row>;
    });


    return <Col md={props.coll} className="webLeads-selected">
        <Row>
            <Col md="12"><strong>{t("application_strings.views.leads.leadGrid.leadDetails")}</strong></Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.leadSource")}</label></Col>
            <Col md="8" >{leadData.LeadSourceDescription}</Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.firstName")}</label></Col>
            <Col md="8" >{leadData.ContactFirstName}</Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.lastName")}</label></Col>
            <Col md="8" >{leadData.ContactLastName}</Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.email")}</label></Col>
            <Col md="8" >
                <div className="d-flex justify-content-between">
                    <div>{leadData.ContactEmail}</div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.mobile")}</label></Col>
            <Col md="8" >
                <div className="d-flex justify-content-between">
                    <div>{leadData.ContactMobile}</div>
                </div>

            </Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.workPh")}</label></Col>
            <Col md="8" >{leadData.ContactWorkPh}</Col>
        </Row>
        <Row>
            <Col md="4" ><label>{t("application_strings.views.leads.leadGrid.homePh")}</label></Col>
            <Col md="8" >{leadData.ContactHomePh}</Col>
        </Row>
        <hr />
        <Row>
            <Col md="12" ><strong>{t("application_strings.views.leads.leadGrid.productsOfInterest")}</strong></Col>
        </Row>
        {poi}
        <hr />
        <Row>
            <Col md="12" ><strong>{t("application_strings.views.leads.leadGrid.customProperties")}</strong></Col>
        </Row>
        {custom}
    </Col>

})






